export const DataType = {
  RANGE: "Range",
  NUMERIC: "Numeric",
  ALPHANUMERIC: "Alphanumeric",
  LOGICAL: "Logical",
  STRING: "String",
};

export const DataTypesList = Object.values(DataType);

export const shouldRedirectToLogin = (error) => {
  const requiredLoginMessages = [
    "missing refresh token",
    "login_required",
    "invalid_grant",
  ];
  const message = (error?.message || "").toLowerCase();

  return requiredLoginMessages.some((msg) => message.includes(msg));
};

export const isImage = (str) => {
  return /\.(jpg|jpeg|png|gif|webp|svg|bmp|tif|jfif)$/i.test(str);
};

export const PageSessionKey = {
  EDIT_PAGEVALUE: `EDIT_PAGEVALUE`,
  EDIT_INCLUDEDFEATURE: `EDIT_INCLUDEDFEATURE`,
  EDIT_FEATURE: `EDIT_FEATURE`,
};
